import { Point } from '../types/point';

export const arrayToSvgPath = (points: Point[], relativeTo: Point = { x: 0, y: 0 }): string => {
  const firstPoint = points[0];
  if (!firstPoint) {
    return '';
  }

  const mappedPoints = points
    .map((pointOnPath) => ({
      x: pointOnPath.x - relativeTo.x,
      y: pointOnPath.y - relativeTo.y,
    }))
    .map((pointOnPath) => `${pointOnPath.x},${pointOnPath.y}`)
    .join(',');
  return `M${firstPoint.x - relativeTo.x},${firstPoint.y - relativeTo.y}L${mappedPoints}`;
};
